import { Controller } from "stimulus";

export default class extends Controller {
  static values = {
    text: String,
    content: String,
    markCopiedUrl: String
  }

  copy(event) {
    event.preventDefault();
    const button = event.currentTarget;
    const textToCopy = this.textValue || button.dataset.clipboardText;

    if (!textToCopy) {
      console.error("No text to copy");
      return;
    }

    this.copyToClipboard(textToCopy, button);
  }

  copyAll(event) {
    event.preventDefault();
    const button = event.currentTarget;
    const textToCopy = this.contentValue;

    if (!textToCopy) {
      console.error("No content to copy");
      return;
    }

    this.copyToClipboard(textToCopy, button);
  }

  copyToClipboard(text, button) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(() => {
        this.showSuccessMessage(button);
        this.markAsCopied();
      }).catch(err => {
        console.error("Failed to copy text: ", err);
        this.fallbackCopyTextToClipboard(text, button);
      });
    } else {
      this.fallbackCopyTextToClipboard(text, button);
    }
  }

  fallbackCopyTextToClipboard(text, button) {
    const textArea = document.createElement("textarea");
    textArea.value = text;
    textArea.style.position = 'fixed';
    textArea.style.top = '-1000px';
    textArea.style.left = '-1000px';
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
      document.execCommand('copy');
      this.showSuccessMessage(button);
      this.markAsCopied();
    } catch (err) {
      console.error('Fallback: Unable to copy', err);
    }

    document.body.removeChild(textArea);
  }

  showSuccessMessage(button) {
    // Swap only an opted-in label so compact controls keep their size
    const feedbackLabel = button.querySelector("[data-clipboard-feedback]")
    if (feedbackLabel) {
      if (!feedbackLabel.dataset.clipboardOriginal) feedbackLabel.dataset.clipboardOriginal = feedbackLabel.textContent
      feedbackLabel.textContent = feedbackLabel.dataset.clipboardFeedback
      clearTimeout(this.feedbackTimeout)
      this.feedbackTimeout = setTimeout(() => { feedbackLabel.textContent = feedbackLabel.dataset.clipboardOriginal }, 2000)
      return
    }

    // If inside an action-item, add a check icon inline instead of replacing content
    const actionTitle = button.querySelector(".action-text .font-weight-bold")
    if (actionTitle) {
      const check = document.createElement("span")
      check.className = "fas fa-check text-success ml-2"
      actionTitle.appendChild(check)
      setTimeout(() => check.remove(), 2000)
      return
    }

    const originalContent = button.innerHTML;
    button.innerHTML = "<span class='fas fa-check text-success'></span>";

    setTimeout(() => {
      button.innerHTML = originalContent;
    }, 2000);
  }

  markAsCopied() {
    const url = this.markCopiedUrlValue;
    if (!url) return;

    fetch(url, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content
      }
    }).then(response => {
      if (response.ok) {
        // Find and update the row to show it was copied
        const row = this.element.closest('tr');
        if (row) {
          const copiedCell = row.querySelector('.copied-status');
          if (copiedCell) {
            copiedCell.innerHTML = "<span class='badge badge-info'>Copied</span>";
          }
        }
      }
    }).catch(err => {
      console.error('Failed to mark as copied:', err);
    });
  }
}
